// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-loading[data-v-32d091ca] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    width: 100%;\n    height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
